import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 20px;
`;
